<template>
	<div>
		<div class="RouterHeaderBox" @mouseover="showtab1()" @mouseout="showtab2()">
			<div class="box">
				<!-- 首页logo -->
				<div class="logo" @click="back('/')">
					<img src="../assets/image/caida.jpg" alt="" />
					<!-- <h1>财达期货</h1> -->
				</div>
				<div class="title" :class="n == 1 ? 'activee' : ''">
					<div class="title-content" @click="back('/', 1)">
						{{ lan == "en" ? "About Amore" : "首页" }}
					</div>
					<div class="title-b" :class="n == 1 ? 'active' : ''"></div>
				</div>
				<div class="title" v-for="(menu, index) in menuList" :key="index"
					:class="n == index + 2 ? 'activee' : ''">
					<div class="title-content" v-if="menu.name === '产品列表' && !token" @click="backLogin">
						{{ menu.name === '产品列表' ? '资产管理' : menu.name }}
					</div>
					<div class="title-content" v-else @click="back('/WineCulture?type=' + menu.id, index + 2)">
						{{ menu.name === '产品列表' ? '资产管理' : menu.name }}
					</div>
					<div class="title-b" :class="n == index + 2 ? 'active' : ''"></div>
					<div v-if="menu.id != 5 && menu.id != 110" class="nav-box">
						<div style="overflow: hidden">
							<div class="nav-items">
								<div></div>
								<h5 v-if="
                    menu.children &&
                    menu.children.filter(
                      (item) => item.children && item.children.length > 0
                    ).length === 0
                  " @click="
                    backItem('/WineCulture?type=' + menu.id, menu.id, index + 2)
                  ">
									{{ menu.name }}
								</h5>
								<ul v-if="
                    menu.children &&
                    menu.children.filter(
                      (item) => item.children && item.children.length > 0
                    ).length === 0
                  ">
									<li v-for="(item, idx) in menu.children" :key="idx" @click="
                      backChildrenNew(
                        '/WineCulture?type=' + menu.id + '&id=' + item.id,
                        item.id,
                        index + 2
                      )
                    ">
										{{ item.name }}
									</li>
								</ul>
								<!-- <HeaderSideBar v-else :menuList="menu.children" :id="menu.id" @change="change" /> -->
								<div class="nav-items" v-else v-for="(item, idx) in menu.children" :key="idx">
									<div></div>
									<h5 @click="backChildren(menu, item, index + 2)">
										{{ item.name }}
									</h5>
									<ul v-if="item.children">
										<li v-for="(v, i) in item.children" :key="i"
											@click="backChildren(menu, v, index + 2)">
											{{ v.name }}
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="login">
					<div class="login-img">
						<!-- <p
              v-if="!token"
              style="
                font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular !important;
                font-weight: normal;
                font-size: 16px;
                color: #3d3d3d;
                cursor: pointer;
              "
              @click="back('/Login', 10)"
            >
              登录
            </p> -->
						<!-- <img
              v-if="!token"
              class="img-icon"
              src="../assets/image/avatar.jpg"
              alt=""
              @click="back('/Login', 10)"
            /> -->
						<img v-if="token" class="img-head" :src="imgUrl(img)" alt=""
							@click="back('/PersonalCenter', 10)" />
						<div class="login-box" v-if="token">
							<div style="overflow: hidden">
								<div class="login-items">
									<ul>
										<li @click="back('/PersonalCenter')">个人中心</li>
										<li @click="logout">退出登录</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div
          class="title search"
          v-show="$route.path !== '/Login'"
          @click.stop="openSearchBtn"
        >
          <div class="search-img">
            <img src="../assets/image/login.png" alt="" />
          </div>
          <div style="overflow: hidden">
            <div class="search-box" v-show="openSearch">
              <input type="text" />
              <div class="search-btn">搜索</div>
            </div>
          </div>
        </div> -->
			</div>
		</div>
		<div class="q">
			<div class="header">
				<div class="header-img" @click="back('/')">
					<img src="@/assets/image/logo(2).png" alt="" class="SchoolLogo1" />
				</div>
				<!-- 三横杠 -->
				<div class="right-img">
					<div class="header-img2">
						
						<img src="@/assets/image/nav.png" alt="" @click="drawerOpen" class="SchoolLogo2" />
					</div>
				</div>
			</div>
		</div>
		<!-- </div> -->
		<div style="z-index: 2000">
			<el-drawer :visible.sync="drawer" :height="drawerHeight" :direction="direction">
				<div class="Qtitle" @click="back('/')">
					{{ lan == "en" ? "Home" : "首页" }}
				</div>
				<HeaderSideBar style="height: 100%" :menuList="menuList" :id="id" :img="imgUrl(img)" :token="token"
					@drawerClose="drawerClose" @change="change" />
				<!-- <div class="fay title login">
          <img src="../assets/image/容器.png" alt="" />
        </div>
        <div class="fay title search">
          <img src="../assets/image/容器.png" alt="" />
        </div> -->
			</el-drawer>
		</div>
		<a href="" v-show="false" ref="tels"></a>
	</div>
</template>
<script>
	import {
		verifyLogin,
		info
	} from "@/api/user";
	import HeaderSideBar from "./HeaderSideBar.vue";
	export default {
		components: {
			HeaderSideBar
		},
		props: {
			lan: String,
			menuList: Array,
		},
		data() {
			return {
				n: 0,
				drawer: false,
				direction: "rtl",
				color: "",
				height: "",
				detail: "",
				drawerHeight: "900px",
				id: 1,
				title: "",
				child: [],
				openSearch: false,
				img: "",
				token: "",
			};
		},
		watch: {
			$route(newValue, oldValue) {
				this.n = 1;
				if (this.$route.query && this.$route.query.type) {
					for (const index in this.menuList) {
						if (this.$route.query.type == this.menuList[index].id) {
							this.n = parseInt(index) + 2;
						}
					}
				}
				
				this.verifyLogin();
			},
		},
		
		mounted() {
			console.log(this.$route.type)
			this.verifyLogin();
			let that = this;
			window.onscroll = () => {
				let height = window.innerHeight / 3;
				that.color = `rgba(30,30,30,${
        document.documentElement.scrollTop / height
      })`;
			};
			this.height = (window.innerHeight * 1) / 2;
			this.height1 = (window.innerHeight * 1) / 3;
			window.onresize = () => {
				this.height = (window.innerHeight * 1) / 2;
				this.height1 = (window.innerHeight * 1) / 3;
			};
		},
		updated() {
			this.verifyLogin();
			this.token = localStorage.getItem("token") && localStorage.getItem("token") != "undefined" ? localStorage
				.getItem("token") : "";
		},
		methods: {
			imgUrl(e) {
				if (!e) {
					return "../assets/image/moren.png";
				} else if (e.substring(0, 4) != "http") {
					return "https://www.caidaqh.com" + e;
				} else {
					return e;
				}
			},
			change(data) {
				console.log(this.data);
				console.log(this.token, data.item.id);
				if (data.item.id === data.id) {
					if (this.$route.query.type !== item.id) {
						this.back("/WineCulture?type=" + item.id);
					}
				} else if (!data.item.children || data.item.children.length === 0) {
					if (data.id == 5) {
						this.back("/Login");
						// this.back("/WineCulture?type=" + data.id + "&id=" + data.item.id);
					} else {
						this.back("/WineCulture?type=" + data.id + "&id=" + data.item.id);
					}
				}
			},
			backChildren(menu, item, index) {
				let id = item.id;
				if (item.children && item.children.length > 0) {
					id = this.getId(item.children).id;
				}
				this.back("/WineCulture?type=" + menu.id + "&id=" + id, index);
			},
			getId(list) {
				const item = list[0];
				if (!item.children || item.children.length == 0) {
					return item;
				} else {
					return this.getId(item.children);
				}
			},
			callPhone(phoneNumber) {
				this.$refs.tels.href = `tel://` + phoneNumber;
				this.$refs.tels.click();
			},
			showtab1() {
				this.color = `rgba(30,30,30,1)`;
				clearTimeout(this.timeout);
			},
			showtab2() {
				this.timeout = setTimeout(() => {
					let height = window.innerHeight / 3;
					this.color = `rgba(30,30,30,${
          document.documentElement.scrollTop / height
        })`;
				}, 100);
			},
			drawerOpen() {
				this.drawer = true;
			},
			drawerClose() {
				this.drawer = false;
			},
			backItem(i, id, idx) {
				this.n = idx;
				if (!this.token && id == 5) {
					this.$router.push("/Login");
				} else {
					this.$router.push(i);
				}
				this.drawer = false;
			},
			backChildrenNew(i, id, idx) {
				this.n = idx;
				if (
					(!this.token && id == 42) || (!this.token && id == 43) || (!this.token && id == 44) || (!this.token &&
						id == 45)) {
					this.$router.push("/Login");
				} else {
					this.$router.push(i);
				}
				this.drawer = false;
			},
			back(i, idx) {
				this.n = idx;
				this.$router.push(i);
				this.drawer = false;
			},
			backLogin() {
				this.$router.push("/Login");
				this.drawer = false;
			},
			openSearchBtn() {
				this.openSearch = !this.openSearch;
			},
			adjustHeight(newHeight) {
				this.drawerHeight = newHeight;
			},
			handleCurrentChange(e) {
				this.page = e;
				this.getList();
			},
			verifyLogin() {
				this.toekn = localStorage.getItem("token") && localStorage.getItem("token") != "undefined" ? localStorage
					.getItem("token") : "";
				if (this.token) {
					verifyLogin().then((res) => {
						if (res.data.code !== 0) {
							this.token = "";
							localStorage.removeItem("token");
						} else {
							info().then((res) => {
								this.img = res.data.data.avatar;
							});
						}
					});
				}
			},
			logout() {
				localStorage.removeItem("token");
				this.$store.dispatch("logout");
				this.$router.push("/Login");
				
			},
		},
	};
</script>
<style lang="scss" scoped>
	.q {
		display: none;
		position: relative;

		@media (max-width: 1200px) {
			display: block;
			height: 80px;
			// position: fixed;
			// transition: all 0.3s linear;
		}

		@media (max-width: 800px) {
			width: 100%;
			// margin: 0 auto;
			height: 60px;
		}

		.header {
			width: 100%;
			height: 80px;
			position: fixed;
			z-index: 2000;
			align-items: center;
			background-color: #fff;
			border-bottom: 1px solid #00000020;
			box-shadow: 0px 0 2px 0 rgba(0, 0, 0, 0.16);

			@media (max-width: 800px) {
				height: 60px;
			}

			.header-img {
				float: left;
				text-align: right !important;
				width: 60%;
				line-height: 80px;
				margin-left: 2%;

				@media (max-width: 800px) {
					width: 65%;
				}

				@media (max-width: 300px) {
					width: 70%;
				}

				.SchoolLogo1 {
					// width: 217px;
					height: 57px;
					float: left;
					margin-top: 12px;
					margin-left: 12px;

					@media (max-width: 800px) {
						width: 150px;
						height: auto;
					}
				}
			}

			.right-img {
				position: absolute;
				right: 0;
				top: 0;

				// float: right;
				// text-align: right;
				// width: 38%;
				// display: flex;
				@media (max-width: 800px) {
					width: 28%;
				}

				.header-img2 {
					width: 100px;
					height: 40px;
					float: right;
					margin-top: 24px;
					margin-right: 24px;

					@media (max-width: 800px) {
						margin-right: 10px;
						margin-top: 15px;
					}

					@media (max-width: 500px) {
						width: 75px;
					}

					@media (max-width: 300px) {
						width: 55px;
						margin-right: 10px;
						margin-top: 20px;
					}

					.login {
						float: left;
						width: 30px;
						height: 30px;
						background-color: #000000;
						z-index: 99999999999;

						@media (max-width: 300px) {
							width: 20px;
							height: 20px;
						}
					}

					// 三横杠
					.SchoolLogo2 {
						float: right;
						width: 35px;
						height: 35px;
						// background-color: #000000;
						z-index: 99999999999;

						@media (max-width: 300px) {
							width: 20px;
							height: 20px;
						}
					}
				}
			}
		}
	}

	.el-drawer__header {
		margin-bottom: 0px !important;
	}

	.el-drawer__close-btn {
		background-color: white !important;
	}

	.el-drawer__open .el-drawer.rtl {
		height: auto;
		width: 60% !important;
		background: #333 !important;
		color: white !important;
	}

	.el-drawer .Qtitle {
		cursor: pointer;

		@media (max-width: 300px) {
			font-size: 14px !important;
		}
	}

	.el-drawer.rtl {
		background: #333 !important;
		color: white !important;
	}

	.el-drawer__body>* {
		width: 100% !important;
		height: 500px;
		line-height: 57px;
		text-align: center;
		padding: 0 !important;
		// border-bottom: 1px solid white ;
	}

	// .el-drawer__body > * :first-child {
	//   border-top: 1px solid white !important;
	// }
	.el-menu {
		padding: 0 !important;
	}

	.el-menu i {
		display: none !important;
		/* 取消图标 */
	}

	.el-menu-item i {
		display: none !important;
		/* 取消图标 */
	}

	.RouterHeaderBox {
		width: 100%;
		height: 80px;
		background-color: #fff;
		z-index: 2000;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		border-bottom: 1px solid #00000020;
		box-shadow: 0px 0 2px 0 rgba(0, 0, 0, 0.16);

		@media (max-width: 1600px) {
			width: 100%;
			margin: 0 auto;
			// height: ;
		}

		@media (max-width: 1366px) {
			width: 100%;
			margin: 0 auto;
			// height: ;
		}

		@media (max-width: 1200px) {
			display: none;
			// height: ;
		}

		.box {
			max-width: 1600px;
			width: 100%;
			// width: 100%;
			height: 80px;
			margin: 0 auto;
			line-height: 80px;
			// margin: 0 auto;
			display: flex;
			// justify-content: space-around;
			justify-content: center;

			@media (max-width: 1600px) {
				width: 98%;
				height: 80px;
				margin: 0 auto;
			}

			@media (max-width: 1366px) {
				width: 95%;
				height: 80px;
				margin: 0 auto;
			}

			@media (max-width: 1200px) {
				display: none;
			}

			.logo {
				width: 210px;
				height: 50px;
				margin: 0 auto;
				align-self: center;
				cursor: pointer;

				img {
					height: 100%;
				}

				@media (max-width: 1200px) {
					cursor: pointer;
					display: none;
					img {
						height: 100%;
						
					}
				}
				
				
				
				
			}

			.title:hover {
				.title-content {
					// font-weight: bold;
					color: #c11226 !important;
				}

				.title-b {
					width: 55px;
					background-color: #b5002a;
				}
			}

			.title:hover .nav-box {
				// display: block;
				// transition: all 0.6s ease;
				grid-template-rows: 1fr;
				box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
			}

			// .search:hover .search-box {
			//   // display: block;
			//   // transition: all 0.6s ease;
			//   grid-template-rows: repeat(1, 1fr);
			//   box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
			//   // display: block;
			// }
			.activee {
				.title-content {
					color: #b5002a !important;
				}
			}

			.title:nth-child(3) .nav-box {
				transform: translateX(-5%);
			}

			.title:nth-child(4) .nav-box {
				transform: translateX(-20%);
			}

			.title:nth-child(5) .nav-box {
				transform: translateX(-40%);
			}

			.title:nth-child(8) .nav-box {
				transform: translateX(-60%);
			}

			.title:nth-child(9) .nav-box {
				transform: translateX(-80%);
			}

			.title:nth-child(10) .nav-box {
				transform: translateX(-95%);
			}

			.title {
				position: relative;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-right: auto;
				align-self: center;
				cursor: pointer;

				@media (max-width: 1200px) {
					display: none;
				}

				.title-content {
					height: 80px;
					line-height: 80px;
					font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular !important;
					font-weight: normal;
					font-size: 16px;
					color: #3d3d3d;
					transition: color 0.8s !important;
				}

				.title-b {
					// 底部横杠
					width: 5px;
					height: 3px;
					transition: width, background-color 0.5s;
					// background-color: #b5002a;
					background-color: #fff;
					position: absolute;
					top: 95%;
					transform: translateY(-50%);
					left: 50%;
					transform: translateX(-50%);
					text-align: center;

					// display: none;
					@media (max-width: 1200px) {
						width: 80%;
					}
				}

				.nav-box {
					width: 700px;
					// height: 300px;
					position: absolute;
					top: 105%;
					left: 50%;
					transform: translateX(-50%);
					z-index: 1998;
					overflow: hidden;
					background-color: #fff;
					// box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
					transition: top 0.8s;
					display: grid;
					grid-template-rows: 0fr;
					transition: 250ms grid-template-rows ease;

					.nav-items {
						width: auto;
						margin-top: 22px;

						h5 {
							width: 150px;
							height: 24px;
							line-height: 21px;
							font-weight: Medium;
							font-size: 20px;
							font-family: Source Han Sans CN, Source Han Sans CN !important;
							color: #000000;
							padding: 0 10px;
							border-left: 5px solid #c11226;
							margin: 11px 0 11px 42px;
						}
					}

					.nav-items ul {
						min-height: 30px;
						height: auto;
						margin: 0;
						list-style-type: none;
					}

					.nav-items ul:last-child {
						margin-bottom: 20px;
						margin-right: 20px;
					}

					.nav-items li:hover {
						color: #c11226;
					}

					.nav-items li:last-child {
						margin-bottom: 20px;
					}

					.nav-items li {
						height: 24px;
						line-height: 24px;
						float: left;
						font-size: 16px;
						font-family: Source Han Sans CN, Source Han Sans CN !important;
						margin-left: 12px;
					}
				}

				.active {
					// display: block;
					width: 55px;
					background-color: #b5002a;
				}
			}

			.login {
				position: relative;

				.login-img:hover .login-box {
					grid-template-rows: 5fr;
					box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
				}

				.login-img {
					width: 80px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;

					@media (max-width: 1024px) {
						margin-left: 10px;
						margin-right: 10px;
						align-self: center;
						cursor: pointer;
					}

					.img-icon {
						width: 30px;
						height: 30px;
						border-radius: 50%;
						display: block;
						cursor: pointer;
					}

					.img-head {
						width: 30px;
						height: 30px;
						border-radius: 50%;
						display: block;
					}

					.login-box {
						width: 150px;
						position: absolute;
						top: 105%;
						left: 50%;
						transform: translateX(-50%);
						z-index: 1998;
						background-color: #f9f9f9;
						overflow: hidden;
						display: grid;
						grid-template-rows: 0fr;
						transition: 500ms grid-template-rows ease !important;
						transition: 250ms box-shadow ease;

						.login-items ul {
							width: 90%;
							margin: 10px auto;
							list-style-type: none;
							padding: 0;

							li:hover {
								background-color: #ecf5ff;
							}

							li {
								width: 100%;
								min-height: 50px;
								line-height: 50px;
								margin: 0 auto;
								text-align: center;
								background-color: #fff;
								transition: background-color 0.5s ease;
								cursor: pointer;
							}
						}
					}
				}
			}

			.search {
				margin-right: 15px;
				position: relative;

				.search-img {
					width: 40px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 19px;
						height: 19px;
						display: block;
					}
				}

				.search-box {
					width: 370px;
					min-height: 67px;
					height: 67px;
					position: absolute;
					top: 105%;
					right: -15px;
					background-color: #f9f9f9;
					box-sizing: border-box;
					border: 1px solid #f1f1f1;
					border-radius: 10px;
					transition: top 0.8s;
					background-color: #fff;
					transition: top 0.8s;

					@media (max-width: 800px) {
						width: 80%;
						max-width: 370px;
					}

					input {
						width: 66%;
						float: left;
						margin-top: 10px;
						box-sizing: border-box;
						height: 48px;
						margin-left: 11px;
						border: 1px solid #e3e8f0;
						border-radius: 10px;
					}

					.search-btn {
						width: 30%;
						float: right;
						height: 48px;
						// margin-left: 10px;
						margin-top: 10px;
						background-color: #fff;
						font-family: Microsoft YaHei, Microsoft YaHei;
						font-weight: 400;
						font-size: 18px;
						color: #a1a6bb;
						line-height: 48px;
						text-align: center;
						border-radius: 10px;
						cursor: pointer;

						@media (max-width: 500px) {
							width: 25%;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/RouterHeader.vue